/**
 * UI elements
 */
class Lami_UI {
  constructor() {
    this.initTimer()
    this.initDynamicCounters();
    this.initClosePopups();
  }

  initTimer() {
    if (!$('.jb-timer-wrapper').length) {
      return;
    }

    $('.jb-timer-wrapper').each((i, countdown) => {
      let countdownElements = {
        daysValue: $(countdown).find('.jb-timer-days-count'),
        daysSuffix: $(countdown).find('.jb-timer-days-label'),
        hoursValue: $(countdown).find('.jb-timer-hours-count'),
        hoursSuffix: $(countdown).find('.jb-timer-hours-label'),
        minutesValue: $(countdown).find('.jb-timer-minutes-count'),
        minutesSuffix: $(countdown).find('.jb-timer-minutes-label'),
        secondsValue: $(countdown).find('.jb-timer-seconds-count'),
        secondsSuffix: $(countdown).find('.jb-timer-seconds-label'),
      };

      this.initCalculateTimer($(countdown), countdownElements);
    });
  }

  initCalculateTimer(countdown, countdownElements) {
    let countTo = parseInt(countdown.attr('data-timestamp-utc'), 10) * 1000;
    let currentTime = new Date().getTime();

    if (countTo - currentTime > 0) {
      let diff = countTo - currentTime;
      let days = Math.floor(diff / (24 * 60 * 60 * 1000));
      let hoursDiff = diff - (days * 24 * 60 * 60 * 1000);
      let hours = (Math.floor(hoursDiff / (60 * 60 * 1000))) % 24;
      let minutesDiff = hoursDiff - (hours * 60 * 60 * 1000);
      let minutes = (Math.floor(minutesDiff / (60 * 1000))) % 60;
      let seconds = Math.floor((minutesDiff - (minutes * 60 * 1000)) / 1000);
      let daysSuffix = days === 1 ? 'd' : 'd';
      let hoursSuffix = 'g';
      let minutesSuffix = 'm';
      let secondsSuffix = 's';

      if (hours === 1) {
        hoursSuffix = 'g';
      } else if (hours === 2 || hours === 3 || hours === 4 || hours === 22 || hours === 23) {
        hoursSuffix = 'g';
      }

      if (minutes === 1) {
        minutesSuffix = 'm';
      } else if (
        minutes === 2 || minutes === 3 || minutes === 4 ||
        minutes === 22 || minutes === 23 || minutes === 24 ||
        minutes === 32 || minutes === 33 || minutes === 34 ||
        minutes === 42 || minutes === 43 || minutes === 44 ||
        minutes === 52 || minutes === 53 || minutes === 54
      ) {
        minutesSuffix = 'm';
      }

      if (seconds === 1) {
        secondsSuffix = 's';
      } else if (
        seconds === 2 || seconds === 3 || seconds === 4 ||
        seconds === 22 || seconds === 23 || seconds === 24 ||
        seconds === 32 || seconds === 33 || seconds === 34 ||
        seconds === 42 || seconds === 43 || seconds === 44 ||
        seconds === 52 || seconds === 53 || seconds === 54
      ) {
        secondsSuffix = 's';
      }

      countdownElements.daysValue.text(days);
      countdownElements.daysSuffix.text(daysSuffix);
      countdownElements.hoursValue.text(hours);
      countdownElements.hoursSuffix.text(hoursSuffix);
      countdownElements.minutesValue.text(minutes);
      countdownElements.minutesSuffix.text(minutesSuffix);
      countdownElements.secondsValue.text(seconds);
      countdownElements.secondsSuffix.text(secondsSuffix);

      if (days === 0) {
        countdownElements.daysValue.parent().addClass('is-hidden');
      } else {
        countdownElements.daysValue.parent().removeClass('is-hidden');
      }

      if (hours === 0) {
        countdownElements.hoursValue.parent().addClass('is-hidden');
      } else {
        countdownElements.hoursValue.parent().removeClass('is-hidden');
      }

      if (minutes === 0) {
        countdownElements.minutesValue.parent().addClass('is-hidden');
      } else {
        countdownElements.minutesValue.parent().removeClass('is-hidden');
      }

      setTimeout(() => {
        this.initCalculateTimer(countdown, countdownElements);
      }, 1000);
    } else {
      countdown.addClass('is-hidden');
      // countdown.find('.jb-timer').addClass('is-hidden');
      // countdown.find('.jb-timer-title').addClass('is-hidden');
      // countdown.find('.jb-timer-finished').removeClass('is-hidden');
      // $('.jb-timer-button-to-hide').addClass('is-hidden');
      // $('.jb-timer-newsletter').removeClass('is-hidden');
    }
  }

  initDynamicCounters() {
    if (!$('.statistics-list').length) {
      return;
    }

    var top = $('.statistics-list').offset().top;
    var bottom = $('.statistics-list').offset().bottom;

    function detectStatsAnimation() {
      var currentScroll = $(window).scrollTop();

      if (currentScroll + $(window).height() > top || (currentScroll < bottom && currentScroll > top)) {
        $(window).off('scroll', detectStatsAnimation);
        runStatsAnimation();
      }
    }

    function runStatsAnimation() {
      $('.statistics-item .number').each(function (i, numberItem) {
        numberItem = $(numberItem);
        var finalValue = parseInt(numberItem.text(), 10);
        var increaseBy = parseInt(numberItem.parent().attr('data-increase-by'), 10);
        var intervalTime = parseInt(numberItem.parent().attr('data-interval'), 10);
        var currentValue = 0;
        numberItem.html('<strong>' + currentValue + '</strong>');

        var intervalIncrease = setInterval(function () {
          currentValue += increaseBy;

          if (currentValue >= finalValue) {
            numberItem.html('<strong>' + finalValue + '</strong>');
            clearInterval(intervalIncrease);
          } else {
            numberItem.html('<strong>' + currentValue + '</strong>');
          }
        }, intervalTime);
      });
    }

    $(window).on('scroll', detectStatsAnimation);
    $(window).trigger('scroll');
  }

  initClosePopups() {
    let infoPopup = $('.popup-info');

    if (!infoPopup.length) {
      return;
    }

    let infoID = infoPopup.attr('data-id');
    infoID = infoID.replace(/[^a-z0-9\-]/gmi, '');
    infoPopup.find('.popup-inner').after('<span class="close-overlay"></span>');
    let infoPopupClose = infoPopup.find('.close');
    let closeOverlay = infoPopup.find('.close-overlay');

    if (!window.localStorage.getItem('lami-www-popup-closed-' + infoID)) {
      infoPopup.removeClass('is-hidden');

      infoPopupClose.on('click', (e) => {
        e.preventDefault();
        infoPopup.addClass('is-hidden');
        window.localStorage.setItem('lami-www-popup-closed-' + infoID, true);
      });

      closeOverlay.on('click', (e) => {
        e.preventDefault();
        infoPopup.addClass('is-hidden');
        window.localStorage.setItem('lami-www-popup-closed-' + infoID, true);
      });
    }
  }
}
